/**
 * @module use-cases/utilities/flux/create-action
 * @desc Helper functions for creating actions.
 *
 */

import { createActionRtk } from '../lib';

import type { ErrorResponse, Meta } from './flux.d';

/**
 * Creates an action with the default payload signature.
 *
 * @template T - The action Type.
 * @template M - The action Meta.
 *
 * @example createAction<'setAuthToken', PayloadType>('setAuthToken');
 */
export function createAction<T extends string, P = undefined>(type: T) {
  return createActionRtk(type, (payload?: P, error?: ErrorResponse, meta?: Meta) => ({
    payload,
    meta,
    error,
  }));
}
